import type { ReactElement } from 'react';
import { GAMES } from '../engine';
import { formatPercent } from '../lib/format';

/**
 * Permanently visible, on every screen. Required by CLAUDE.md, and it is the only
 * honest number in the application: whatever the grid, a euro staked is worth
 * about half a euro back. Nothing in this app changes that, and nothing in it
 * claims to.
 */
export function RtpBar(): ReactElement {
  return (
    <div className="rtp-bar" role="note">
      <span aria-hidden="true">⚠︎</span>
      <span>
        Taux de retour au joueur : <b>{formatPercent(GAMES.loto.rtp ?? 0, 1)}</b> au Loto,
        environ <b>50 %</b> à l’EuroMillions. L’espérance de gain est négative pour toute
        grille. Cette application ne change pas la probabilité de gagner.
      </span>
    </div>
  );
}
